<script lang="ts">
  import CountrySelector from "./country-selector.svelte"
  import { defaultOptions } from "."
  import { cn } from "$lib/utils"
  import { TelInput, normalizedCountries } from "svelte-tel-input"
  import "svelte-tel-input/styles/flags.css"

  const countries = normalizedCountries

  interface Props {
    className?: string | undefined
    defaultCountry?: string | null
    country?: string | null
    options?: any
    placeholder?: string | undefined
    readonly?: boolean
    disabled?: boolean
    value?: string | undefined
    valid?: boolean
    detailedValue?: any
    order?: ((a: any, b: any) => number) | undefined
    name?: string | undefined
    [key: string]: any
  }

  let {
    className = undefined,
    defaultCountry = null,
    country = $bindable(defaultCountry),
    options = defaultOptions,
    placeholder = $bindable(undefined),
    readonly = $bindable(false),
    disabled = $bindable(false),
    value = $bindable(undefined),
    valid = $bindable(false),
    detailedValue = $bindable(undefined),
    order = undefined,
    name = undefined,
    ...rest
  }: Props = $props()

  let el: HTMLInputElement | undefined = $state()

  export const focus = () => {
    // sort of an after update kinda thing
    setTimeout(() => {
      el?.focus()
    }, 0)
  }
</script>

<div class="flex place-items-center">
  <CountrySelector
    {order}
    {countries}
    bind:selected={country}
    on:select={focus}
  />
  <div
    class="tel-input focus-visible:outline-none border border-l-0 placeholder:text-black shadow-sm h-9 flex justify-center items-center w-full rounded-md rounded-l-none pl-2"
  >
    <TelInput
      {name}
      bind:country
      bind:detailedValue
      bind:value
      bind:valid
      bind:readonly
      bind:disabled
      bind:placeholder
      bind:el
      {options}
      required
      class={cn(
        "flex h-10 w-[212px] rounded-lg rounded-l-none border border-l-0 border-input bg-background px-3 py-2 text-sm ring-offset-background file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    />
  </div>
</div>

<style>
  :global(input:focus) {
    outline: none !important;
  }
  :global(.tel-input input) {
    background-color: transparent !important;
  }
</style>
